/**
 * PC 路由 ↔ 移动端路由的映射表。
 *
 * 刻意用显式枚举而不是模糊匹配：漏掉的路由会落到默认兜底，
 * 比"猜一个可能不存在的移动端页面"安全。
 */

/** PC → 移动端 */
export const PC_TO_MOBILE = {
  '/': '/m',
  '/index': '/m',
  '/recitation': '/m/recitation',
  '/testcenter': '/m/testbank',
  '/userhome': '/m/mine',
  '/wrong-questions': '/m/mine/wrong',
  '/courseclassification': '/m/course'
}

/** 移动端 → PC，用于「切换到电脑版」 */
export const MOBILE_TO_PC = {
  '/m': '/index',
  '/m/recitation': '/recitation',
  '/m/testbank': '/testcenter',
  '/m/mine': '/userhome',
  '/m/mine/wrong': '/wrong-questions',
  '/m/course': '/courseclassification',
  '/m/login': '/index'
}

/**
 * 移动端明确不做、必须留在 PC 的功能。
 * 手机访问这些路由时不跳转，而是显示一个「请用电脑访问」的提示页。
 */
export const PC_ONLY_ROUTES = [
  '/examcenter',      // 考试：防作弊、监考、断线续考在手机上无法保证
  '/exam-detail',
  '/kaoshidaojishi',
  '/teacher-panel',   // 教师管理端
  '/pka_category_list', '/pka_assignment',      // 思科判题：需上传工程文件
  '/vb_category_list', '/vb_assignment',        // VB 判题
  '/server_category_list', '/server_assignment', // 服务器判题
  '/serveset',
  '/tool',            // 开发者工具箱
  '/ocr'
]

/** 带参数的动态路由前缀映射，如 /testbank-detail/12 → /m/testbank/12 */
const DYNAMIC_PREFIX = [
  { pc: '/testbank-detail/', mobile: '/m/testbank/' },
  { pc: '/recitation-detail/', mobile: '/m/recitation/' }
]

/**
 * 课程详情 PC 端是 /videodetailspage?id=12（query 传参），
 * 移动端是 /m/course/12（path 传参），两者形态不同，单独处理。
 */
const COURSE_PC_PATH = '/videodetailspage'
const COURSE_MOBILE_PREFIX = '/m/course/'

/**
 * 把 PC 路径解析成对应的移动端路径
 * query 单独返回 —— vue-router 的 next({path}) 对象形式不解析 path 里的 ?xxx
 * @returns {{ type: 'map'|'pcOnly'|'fallback', path: string, query?: Object }}
 */
export function resolveMobilePath(pcPath, pcQuery) {
  // 课程详情要把 ?id=12 提到 path 里
  if (pcPath === COURSE_PC_PATH) {
    const id = pcQuery && pcQuery.id
    return id
      ? { type: 'map', path: COURSE_MOBILE_PREFIX + id }
      : { type: 'map', path: '/m/course' }
  }

  if (PC_TO_MOBILE[pcPath]) {
    return { type: 'map', path: PC_TO_MOBILE[pcPath] }
  }

  for (const rule of DYNAMIC_PREFIX) {
    if (pcPath.indexOf(rule.pc) === 0) {
      return { type: 'map', path: rule.mobile + pcPath.slice(rule.pc.length) }
    }
  }

  const hitPcOnly = PC_ONLY_ROUTES.some(r => pcPath === r || pcPath.indexOf(r + '/') === 0)
  if (hitPcOnly) {
    return { type: 'pcOnly', path: '/m/pc-only', query: { from: pcPath } }
  }

  // 没有对应移动端页面的，回首页而不是白屏
  return { type: 'fallback', path: '/m' }
}

/** 把移动端路径解析成对应的 PC 路径 */
export function resolvePcPath(mobilePath) {
  if (MOBILE_TO_PC[mobilePath]) return MOBILE_TO_PC[mobilePath]

  // 课程详情反向：/m/course/12 → /videodetailspage?id=12
  if (mobilePath.indexOf(COURSE_MOBILE_PREFIX) === 0) {
    const rest = mobilePath.slice(COURSE_MOBILE_PREFIX.length)
    // play 页在 PC 端没有独立路由，回课程列表
    if (!rest || rest === 'play') return '/courseclassification'
    return COURSE_PC_PATH + '?id=' + rest
  }

  for (const rule of DYNAMIC_PREFIX) {
    if (mobilePath.indexOf(rule.mobile) === 0) {
      return rule.pc + mobilePath.slice(rule.mobile.length)
    }
  }
  return '/index'
}



// WEBPACK FOOTER //
// ./src/router/mobile-map.js